<template>
  <ControlWrapper
    v-bind="control.controlWrapper.value"
    :styles="control.styles"
    :is-focused="control.isFocused.value"
    :applied-options="control.appliedOptions.value"
    :error="control.control.value.errors"
  >
    <div v-if="items && !Array.isArray(items)" class="widget-base-checkbox-group">
      <label :class="[control.styles.control.label, '!mb-3 inline-block']">{{ control.computedLabel }}</label>
      <p v-if="control?.control.value.description" class="widget-base-checkbox-group_description">
        {{ control.control.value.description }}
      </p>
      <fieldset class="my-6">
        <legend class="sr-only">{{ control.computedLabel }}</legend>
        <div
          :class="twMerge('widget-base-checkbox-group_wrapper', control.styles.control.input)"
          :disabled="!control.control.value.enabled"
          :autofocus="control.appliedOptions.value.focus"
          :placeholder="control.appliedOptions.value.placeholder"
          :hint="control.control.value.description"
          :persistent-hint="control.persistentHint()"
          :required="control.control.value.required"
        >
          <div
            v-for="option in items.enum"
            :key="option.const"
            class="widget-base-checkbox-group_input-wrapper"
            @click="() => (option.checked = !option.checked) && setSelected"
          >
            <WInput
              v-model="option.checked"
              :id="String(option.const)"
              :name="String(option.const)"
              type="checkbox"
              :disabled="!control.control.value.enabled"
              :autofocus="control.appliedOptions.value.focus"
              :placeholder="control.appliedOptions.value.placeholder"
              class="widget-base-checkbox-group_input"
              @update:modelValue="setSelected"
            />

            <label for="checkboxcontrol" class="widget-base-checkbox-group_label">
              {{ option.title }}
            </label>
          </div>
        </div>
      </fieldset>
      <WTextarea
        v-model="note"
        name="note"
        :disabled="!control.control.value.enabled"
        :label="noteOptions?.title || 'Notes'"
        subtitle
        @update:model-value="setNote"
      />
      <p class="body1-bold text-negative-500">{{ control.control.value.errors }}</p>
    </div>
  </ControlWrapper>
</template>

<script setup lang="ts">
  import { ControlElement, JsonSchema7, JsonSchema4 } from '@jsonforms/core';
  import { nextTick, ref, computed } from 'vue';
  import { twMerge } from 'tailwind-merge';
  import { rendererProps, useJsonFormsEnumControl } from '@jsonforms/vue';
  import { default as ControlWrapper } from './ControlWrapper.vue';
  import { useWidgetControl } from '../util';
  import WInput from '../../base/Input.vue';
  import WTextarea from '../../base/Textarea.vue';

  type NoteOptions = {
    title: string;
  };
  type Option = {
    title: string;
    const: string;
    checked: boolean;
  };
  const props = defineProps(rendererProps<ControlElement>());

  const control = useWidgetControl(useJsonFormsEnumControl(props));
  const noteOptions = ref(control.control.value.schema?.properties?.note as NoteOptions);
  const items = computed(() => control.control.value.schema?.properties?.services?.items as JsonSchema4 | JsonSchema7);
  const defaultValue = {
    services: [] as Option[],
    note: '',
  };
  const controlValue = ref(
    control.control.value.data ? (control.control.value.data as typeof defaultValue) : defaultValue
  );
  if (controlValue.value.services?.length) {
    items.value.enum = controlValue.value.services;
  }
  const note = ref(controlValue.value.note);

  function setSelected() {
    control.onChange({ services: items.value.enum, note: note.value });
  }

  function setNote() {
    nextTick(() => {
      control.onChange({ services: items.value.enum, note: note.value });
    });
  }
</script>
